var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Configs } from "../app-lib/constants";
import * as ajax from '../app-lib/ajax_proxy';
var EmptyGuid = "00000000-0000-0000-0000-000000000000";
import * as authorization from "../lib/authorization";
import { Components } from "./component";
var KnockoutModel = /** @class */ (function () {
    function KnockoutModel(url, container, data, isBinded) {
        if (isBinded === void 0) { isBinded = false; }
        this.url = url;
        this.container = container;
        this.data = data;
        this.isBinded = isBinded;
        this.viewModel = ko.observable();
    }
    KnockoutModel.prototype.loadData = function (data2) {
        var _this = this;
        var data1 = this.toJS(data2 || this.data);
        var url1 = this.url;
        if (this.id)
            url1 += "/" + this.id;
        return ajax.get(url1, data1)
            .then(function (d) {
            return _this.onViewModelSetting(d).then(function (isViewModelSet) {
                if (!isViewModelSet) {
                    _this.viewModel(d);
                    _this.onViewModelSet(d);
                }
                _this.bind();
                return d;
            });
        })
            .catch(function (e) { return _this.onException(e); });
    };
    KnockoutModel.prototype.saveData = function (it) {
        var _this = this;
        it = it || this.data;
        var errMsg = this.onValidating(it);
        if (errMsg) {
            return window.popBox.show(errMsg).then(function () { return Promise.resolve(false); });
        }
        var data1 = this.toJS(it);
        return (!this.id || (EmptyGuid == this.id)
            ? ajax.post(this.url, data1) :
            ajax.put(this.url + "/" + this.id, data1))
            .then(function (d) { _this.onSaveSuccess(); return d; })
            .catch(function (e) { return _this.onException(e) && false; });
    };
    KnockoutModel.prototype.deleteData = function (ids) {
        var _this = this;
        if (ids && ids.length) {
            return window.popBox.show("是否确认删除？", {
                isConfirmModal: true
            })
                .then(function () { return ajax.deleteIt(_this.url, ids)
                .then(function (d) { return true; })
                .catch(function (e) { return _this.onException(e) && false; }); }, function () { return false; });
        }
        else
            window.popBox.show("请选择要删除的项目。");
        return Promise.resolve(false);
    };
    KnockoutModel.prototype.bind = function () {
        if (!this.isBinded) {
            ko.applyBindings(this, this.container);
            this.isBinded = true;
        }
    };
    KnockoutModel.prototype.toJS = function (t) {
        var r = ko.utils.unwrapObservable(t);
        if ("object" != typeof r || r instanceof Date || null === r)
            return r;
        r = {};
        for (var n in t)
            if (t.hasOwnProperty(n)) {
                var e = ko.utils.unwrapObservable(t[n]);
                if (Array.isArray(e)) {
                    r[n] = [];
                    for (var o in e)
                        r[n][o] = this.toJS(e[o]);
                    continue;
                }
                if ("object" == typeof e && !(e instanceof Date) && null !== e) {
                    r[n] = this.toJS(e);
                    continue;
                }
                r[n] = e;
            }
        return r;
    };
    KnockoutModel.prototype.onViewModelSetting = function (d) { return Promise.resolve(false); }; //return true if viewModel was set here
    KnockoutModel.prototype.onViewModelSet = function (d) { };
    KnockoutModel.prototype.onValidating = function (d) { return ""; };
    KnockoutModel.prototype.onSaveSuccess = function () { };
    KnockoutModel.prototype.onException = function (err) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (err.handled)
                            return [2 /*return*/];
                        console.error(err);
                        if (err.message == "") {
                            err.message = "此功能维护中";
                        }
                        return [4 /*yield*/, window.popBox.show(err.message)];
                    case 1:
                        _a.sent();
                        if (parseInt(err.status) === 1) {
                            authorization.signOut();
                            throw { handled: true };
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    return KnockoutModel;
}());
ko.bindingHandlers.stopBindings = {
    init: function () {
        return { controlsDescendantBindings: true };
    }
};
ko.bindingHandlers["pageComponent"] = {
    init: function (element, valueAccessor, allBindingsAccessor) {
        var opt = valueAccessor();
        console.log("=========." + opt.params);
        var components = Components;
        console.log(components[opt.name]);
        components[opt.name].initComponent(opt.params).renderTo(element, true);
        return { controlsDescendantBindings: true };
    }
};
var componentBackup = ko.bindingHandlers.component;
ko.bindingHandlers.component = {
    init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
        var components = Components;
        var componentInfo = valueAccessor();
        if (components[componentInfo.name] == null) {
            return componentBackup.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        }
        var options = componentInfo.params && componentInfo.params.options;
        options = options || componentInfo.params;
        var c = components[componentInfo.name].initComponent(options);
        c.renderTo(element, true);
        c.update().then(function () { return c.onInitComplete(); });
        ko.applyBindings(c, c.container);
        return { controlsDescendantBindings: true };
    }
};
ko.bindingHandlers["imgSrc"] = {
    update: function (element, valueAccessor, allBindingsAccessor) {
        var img = element;
        var value = valueAccessor();
        if (ko.isObservable(value))
            value = value();
        img.src = value ? Configs.serviceUrl + value : 'https://bulma.io/images/placeholders/128x128.png';
    }
};
export default KnockoutModel;
